import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';


 const CustomTooltip = styled(({ className, ...props }) => (
   <Tooltip {...props} arrow classes={{ popper: className }} />
 ))(({ theme }) => ({
   [`& .${tooltipClasses.arrow}`]: {
     color: "#000000ff",
   },
   [`& .${tooltipClasses.tooltip}`]: {
     backgroundColor: "#000000ff",
     color: "#ffffffff",
     fontSize: "14px",
     boxShadow: "0 0 10px 0 rgba(0,0,0,0.2)",
   },
 }));
  export default CustomTooltip;
